module.exports = __webpack_public_path__ + "static/media/ApproveCards.661c5a9c.svg";